import { StyledPageContainer, StyledPageContentContainer } from '../../styles/PageStyles'
import { useMediaQuery, useTheme } from '@mui/material'
import { Outlet } from 'react-router-dom'
import Sidebar from '../Sidebar/Sidebar'
import PageHeader from './PageHeader'
import UserService from '../../store/services/UserService'
import { useSelector } from 'react-redux'
import { getSidebarState } from '../../store/redux/reducers/sidebarSlice'

const PageContainer = () => {
  const open = useSelector(getSidebarState)
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const isLoggedIn = UserService.isLoggedIn()

  if (isLoggedIn) {
    return (
      <StyledPageContainer sx={{ pl: open && !isSmallScreen ? theme.spacing(32) : '75px' }} tabIndex={-1}>
        <Sidebar />
        <StyledPageContentContainer sx={{ pr: isSmallScreen ? 2 : 'auto' }}>
          <PageHeader />
          <Outlet />
        </StyledPageContentContainer>
      </StyledPageContainer>
    )
  }

  return <Outlet />
}

export default PageContainer
